<template>
    <div>
        <div v-if="model == 'c1p1s1t1'" class="tile1">
            <div class="audio svg-sync">
                
                <h1>Understand the 3 circle model</h1>
                
                <audio ref="audio1" @timeupdate="onTimeUpdate" controls class="compass" id="audio" :src="baseurl + 'assets/audios/camp1path1step1tile1.mp3'"></audio>
                
                <div class="transcript">
                    <p>Three domains are present:</p>
                    <ul>
                        <li>Family</li>
                        <li>Business</li>
                        <li>Ownership</li>
                    </ul>
                    <p>To illustrate how these three domains interact we need to have them overlap with one an other.</p>
                    <p>Through this lens we can visualize the forces that are in play most of the time in a positive way but sometimes in a competing manner.</p>
                    <p>Once aware of this simple yet complex way of reading a family firm you will uncover many new perspectives that may not have been so obvious to you before.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <h3 style="text-align: center; ">The Three-Circle Model is a framework that has proven to be useful<br />in increasing our understanding of family businesses.</h3>
                    <div id="circles-model">
                        <svg id="SvgjsSvg1000" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%" xmlns:xlink="http://www.w3.org/1999/xlink" class="circles">
                            <g id="SvgjsG1023" class="circles-3" transform="scale(0.7 0.7) translate(0 178.57142857142858)">
                                <g id="circle-1" data-border="none" data-labelPosition="center" data-label="Family" class="family circle-1 text-center" transform="translate(50 -175)">
                                    <ellipse id="SvgjsEllipse1025" rx="200" ry="200" cx="200" cy="200"></ellipse>
                                    <text id="SvgjsText1026" font-family="Helvetica, Arial, sans-serif" x="129.3359375" y="195.89921951293945">
                                        <tspan id="SvgjsTspan1027" dy="20.8" x="129.3359375">Family</tspan>
                                    </text>
                                </g>
                                <g id="circle-2" data-border="none" data-labelPosition="center" data-label="Business" class="business circle-2 text-center" transform="translate(350 -175)">
                                    <ellipse id="SvgjsEllipse1029" rx="200" ry="200" cx="200" cy="200"></ellipse>
                                    <text id="SvgjsText1030" font-family="Helvetica, Arial, sans-serif" x="102.6171875" y="195.95000076293945">
                                        <tspan id="SvgjsTspan1031" dy="20.8" x="102.6171875">Business</tspan>
                                    </text>
                                </g>
                                <g id="circle-3" data-border="none" data-labelPosition="center" data-label="Ownership" class="ownership circle-3 text-center" transform="translate(200.37593984962405 50)">
                                    <ellipse id="SvgjsEllipse1033" rx="200" ry="200" cx="200" cy="200"></ellipse>
                                    <text id="SvgjsText1034" font-family="Helvetica, Arial, sans-serif" x="85.28515625" y="195.95000076293945">
                                        <tspan id="SvgjsTspan1035" dy="20.8" x="85.28515625">Ownership</tspan>
                                    </text>
                                </g>
                            </g>
                            <g id="circles-tooltip" class="circles-tooltip" visibility="hidden">
                                <rect id="circles-tooltip-bg" width="0" height="20" rx="5" ry="5"></rect>
                                <text id="circles-tooltip-text" font-family="Helvetica, Arial, sans-serif" x="6" y="25.700000762939453">
                                    <tspan id="SvgjsTspan1039" dy="20.8" x="6">Tooltip</tspan>
                                </text>
                            </g>
                            <defs id="SvgjsDefs1001"></defs>
                        </svg>
                    </div>
                    <p class="source">Source: Adapted from Tagiuri &amp; Davis (1982)</p>
                </div>
            </div>
        </div>









        <div v-if="model == 'c1p1s1t2'" class="tile2">
            <div class="audio svg-sync">
                <h1>The 7 territories</h1>
                
                <audio ref="audio2" @timeupdate="onTimeUpdate" controls class="compass" id="audio" :src="baseurl + 'assets/audios/camp1path1step1tile2.mp3'"></audio>
                
                <div class="transcript">
                    <p>As a family business member you may be in more than one circle at a given time but you can only be in one of the 7 territories shown here.</p>
                    <p>For example, a family member working in the business but not yet an owner will be in territory #2 . He or she may want to immigrate towards territoty #1 by becoming an owner while maintaining an active role in the business.</p>
                    <p>All 7 territories offer a unique perspective, and may influence someone’s viewpoint about an issue. Keep this in mind it may help you better understand  some of your family members opinions.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div id="seven-territories">
                        <svg id="SvgjsSvg1000" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%" xmlns:xlink="http://www.w3.org/1999/xlink" class="circles">
                            <g id="SvgjsG1120" class="circles-3" transform="scale(0.9 0.9) translate(-94.44444444444444 44.44444444444444)">
                                <g id="circle-1" data-border="none" data-labelPosition="over" data-label="Family" class="family circle-1 text-over" transform="translate(137.5 0)">
                                    <ellipse id="SvgjsEllipse1122" rx="200" ry="200" cx="200" cy="200"></ellipse>
                                    <image id="SvgjsImage1123" :xlink:href="baseurl + 'assets/images/3circles/family.png'" width="96" height="125" x="-25" y="20"></image>
                                </g>
                                <g id="circle-2" data-border="none" data-labelPosition="over" data-label="Business" class="business circle-2 text-over" transform="translate(345.5 -10)">
                                    <ellipse id="SvgjsEllipse1125" rx="200" ry="200" cx="200" cy="200"></ellipse>
                                    <image id="SvgjsImage1126" :xlink:href="baseurl + 'assets/images/3circles/business.png'" width="134" height="144" x="275" y="-20"></image>
                                </g>
                                <g id="circle-3" data-border="none" data-labelPosition="over" data-label="Ownership" class="ownership circle-3 text-over" transform="translate(250 179)">
                                    <ellipse id="SvgjsEllipse1128" rx="200" ry="200" cx="200" cy="200"></ellipse>
                                    <image id="SvgjsImage1129" :xlink:href="baseurl + 'assets/images/3circles/ownership.png'" width="216" height="57" x="90" y="385"></image>
                                </g>
                                <g id="SvgjsG1130" class="zoneNumber">
                                    <text id="circle-number-1" font-family="Helvetica, Arial, sans-serif" class="number" x="441.65234375" y="255.95000076293945" filter="url(#SvgjsFilter1145)" opacity="1" fill="#000000">
                                        <tspan id="SvgjsTspan1132" dy="20.8" x="441.65234375">1</tspan>
                                    </text>
                                    <text id="circle-number-2" font-family="Helvetica, Arial, sans-serif" class="number" x="441.65234375" y="115.95000076293945" filter="url(#SvgjsFilter1149)" opacity="1" fill="#000000">
                                        <tspan id="SvgjsTspan1134" dy="20.8" x="441.65234375">2</tspan>
                                    </text>
                                    <text id="circle-number-3" font-family="Helvetica, Arial, sans-serif" class="number" x="311.65234375" y="315.95000076293945" filter="url(#SvgjsFilter1153)">
                                        <tspan id="SvgjsTspan1136" dy="20.8" x="311.65234375">3</tspan>
                                    </text>
                                    <text id="circle-number-4" font-family="Helvetica, Arial, sans-serif" class="number" x="216.65234375" y="255.95000076293945" filter="url(#SvgjsFilter1157)">
                                        <tspan id="SvgjsTspan1138" dy="20.8" x="216.65234375">4</tspan>
                                    </text>
                                    <text id="circle-number-5" font-family="Helvetica, Arial, sans-serif" class="number" x="571.65234375" y="315.95000076293945" filter="url(#SvgjsFilter1161)">
                                        <tspan id="SvgjsTspan1140" dy="20.8" x="571.65234375">5</tspan>
                                    </text>
                                    <text id="circle-number-6" font-family="Helvetica, Arial, sans-serif" class="number" x="666.65234375" y="255.95000076293945" filter="url(#SvgjsFilter1165)">
                                        <tspan id="SvgjsTspan1142" dy="20.8" x="666.65234375">6</tspan>
                                    </text>
                                    <text id="circle-number-7" font-family="Helvetica, Arial, sans-serif" class="number" x="441.65234375" y="475.95000076293945" filter="url(#SvgjsFilter1169)">
                                        <tspan id="SvgjsTspan1144" dy="20.8" x="441.65234375">7</tspan>
                                    </text>
                                </g>
                            </g>
                            <g id="circles-tooltip" class="circles-tooltip" visibility="hidden">
                                <rect id="circles-tooltip-bg" width="0" height="20" rx="5" ry="5"></rect>
                                <text id="circles-tooltip-text" font-family="Helvetica, Arial, sans-serif" x="6" y="25.700000762939453">
                                    <tspan id="SvgjsTspan1176" dy="20.8" x="6">Tooltip</tspan>
                                </text>
                            </g>
                            <defs id="SvgjsDefs1001">
                                <filter id="SvgjsFilter1145">
                                    <feOffset id="SvgjsFeOffset1146" in="SourceAlpha" result="SvgjsFeOffset1146Out" dx="2" dy="2"></feOffset>
                                    <feGaussianBlur id="SvgjsFeGaussianBlur1147" in="SvgjsFeOffset1146Out" result="SvgjsFeGaussianBlur1147Out" stdDeviation="2"></feGaussianBlur>
                                    <feBlend id="SvgjsFeBlend1148" in="SourceGraphic" result="SvgjsFeBlend1148Out" in2="SvgjsFeGaussianBlur1147Out" mode="normal"></feBlend>
                                </filter>
                                <filter id="SvgjsFilter1149">
                                    <feOffset id="SvgjsFeOffset1150" in="SourceAlpha" result="SvgjsFeOffset1150Out" dx="2" dy="2"></feOffset>
                                    <feGaussianBlur id="SvgjsFeGaussianBlur1151" in="SvgjsFeOffset1150Out" result="SvgjsFeGaussianBlur1151Out" stdDeviation="2"></feGaussianBlur>
                                    <feBlend id="SvgjsFeBlend1152" in="SourceGraphic" result="SvgjsFeBlend1152Out" in2="SvgjsFeGaussianBlur1151Out" mode="normal"></feBlend>
                                </filter>
                                <filter id="SvgjsFilter1153">
                                    <feOffset id="SvgjsFeOffset1154" in="SourceAlpha" result="SvgjsFeOffset1154Out" dx="2" dy="2"></feOffset>
                                    <feGaussianBlur id="SvgjsFeGaussianBlur1155" in="SvgjsFeOffset1154Out" result="SvgjsFeGaussianBlur1155Out" stdDeviation="2"></feGaussianBlur>
                                    <feBlend id="SvgjsFeBlend1156" in="SourceGraphic" result="SvgjsFeBlend1156Out" in2="SvgjsFeGaussianBlur1155Out" mode="normal"></feBlend>
                                </filter>
                                <filter id="SvgjsFilter1157">
                                    <feOffset id="SvgjsFeOffset1158" in="SourceAlpha" result="SvgjsFeOffset1158Out" dx="2" dy="2"></feOffset>
                                    <feGaussianBlur id="SvgjsFeGaussianBlur1159" in="SvgjsFeOffset1158Out" result="SvgjsFeGaussianBlur1159Out" stdDeviation="2"></feGaussianBlur>
                                    <feBlend id="SvgjsFeBlend1160" in="SourceGraphic" result="SvgjsFeBlend1160Out" in2="SvgjsFeGaussianBlur1159Out" mode="normal"></feBlend>
                                </filter>
                                <filter id="SvgjsFilter1161">
                                    <feOffset id="SvgjsFeOffset1162" in="SourceAlpha" result="SvgjsFeOffset1162Out" dx="2" dy="2"></feOffset>
                                    <feGaussianBlur id="SvgjsFeGaussianBlur1163" in="SvgjsFeOffset1162Out" result="SvgjsFeGaussianBlur1163Out" stdDeviation="2"></feGaussianBlur>
                                    <feBlend id="SvgjsFeBlend1164" in="SourceGraphic" result="SvgjsFeBlend1164Out" in2="SvgjsFeGaussianBlur1163Out" mode="normal"></feBlend>
                                </filter>
                                <filter id="SvgjsFilter1165">
                                    <feOffset id="SvgjsFeOffset1166" in="SourceAlpha" result="SvgjsFeOffset1166Out" dx="2" dy="2"></feOffset>
                                    <feGaussianBlur id="SvgjsFeGaussianBlur1167" in="SvgjsFeOffset1166Out" result="SvgjsFeGaussianBlur1167Out" stdDeviation="2"></feGaussianBlur>
                                    <feBlend id="SvgjsFeBlend1168" in="SourceGraphic" result="SvgjsFeBlend1168Out" in2="SvgjsFeGaussianBlur1167Out" mode="normal"></feBlend>
                                </filter>
                                <filter id="SvgjsFilter1169">
                                    <feOffset id="SvgjsFeOffset1170" in="SourceAlpha" result="SvgjsFeOffset1170Out" dx="2" dy="2"></feOffset>
                                    <feGaussianBlur id="SvgjsFeGaussianBlur1171" in="SvgjsFeOffset1170Out" result="SvgjsFeGaussianBlur1171Out" stdDeviation="2"></feGaussianBlur>
                                    <feBlend id="SvgjsFeBlend1172" in="SourceGraphic" result="SvgjsFeBlend1172Out" in2="SvgjsFeGaussianBlur1171Out" mode="normal"></feBlend>
                                </filter>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>



        <div v-if="model == 'c1p1s1t3'" class="tile3">
            <div class="audio svg-sync">
                <h1>Personal Life Cycles</h1>
                
                <audio ref="audio3" @timeupdate="onTimeUpdate" controls class="compass" id="audio" :src="baseurl + 'assets/audios/camp1path1step1tile3.mp3'"></audio>
                
                <div class="transcript">
                    <p>The complexity of business families is obvious when you take a brief look at how many life cycles are in play simultaneously.</p>

                    <p>For instance in the family circle, members of the family are traveling on their own personal developmental journey while also composing with an evolving family setting. Therefore, some family members are beginning their journey and becoming oneself as they settle down and found their own family, while others are thinking about their legacy and taking on a new role as grandparents of a new generation.</p>

                    <p>Our personal journey relates mainly to the developmental stages that influence many aspects of our lives, such as: our needs, our dreams, our concerns and our perceptions of what is important and how we see the world.</p>

                    
                    <p>When you take a step back and look at all the cycles that are in play simultaneously no wonder the dynamics of family business are complex. As you try and navigate all the cycles:</p>
                    <ul>
                        <li>Your personal journey &amp; family phase,</li>
                        <li>The business stages,</li>
                        <li>Your ownership distribution,</li>
                        <li>and the industry’s evolution </li>
                    </ul>
                    &nbsp;
                    <p>All of these cycles have a influence on you, your family and your business.</p>

                    <p>Have you noticed how the time line of life stages has shifted at least 10 years in the last decades?</p>


                    <p>Statistics show that life expectancies have increased almost 15 years in certain countries.</p>

                    <p>How interesting to see the consequences of this shift on business families, the senior generation may be active well beyond the age of 60.</p>

                    <p>This transcends in business families by having more than one generation working together for decades, hence the challenge of redefining our roles and responsibilities.</p>
                </div>
            </div>
           
            <div id="personal-life-cycles" v-if="personal_life_cycles == 1">
                <svg id="SvgjsSvg1000" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%" xmlns:xlink="http://www.w3.org/1999/xlink" class="circles">
                    <g id="SvgjsG1059" class="circles-3" transform="scale(0.9 0.9) translate(-94.44444444444444 27.77777777777778)">
                        <g id="circle-1" data-border="none" data-labelPosition="over" data-label="Family" class="family circle-1 text-over" transform="translate(137.5 10)">
                            <ellipse id="SvgjsEllipse1061" rx="200" ry="200" cx="200" cy="200"></ellipse>
                            <image id="SvgjsImage1062" :xlink:href="baseurl + 'assets/images/3circles/family.png'" width="96" height="125" x="-25" y="20"></image>
                        </g>
                        <g id="circle-2" data-border="none" data-labelPosition="over" data-label="Business" class="business circle-2 text-over" transform="translate(465.5 10)">
                            <ellipse id="SvgjsEllipse1064" rx="200" ry="200" cx="200" cy="200"></ellipse>
                            <image id="SvgjsImage1065" :xlink:href="baseurl + 'assets/images/3circles/business.png'" width="134" height="144" x="275" y="-20"></image>
                        </g>
                        <g id="circle-3" data-border="none" data-labelPosition="over" data-label="Ownership" class="ownership circle-3 text-over" transform="translate(300 254)">
                            <ellipse id="SvgjsEllipse1067" rx="200" ry="200" cx="200" cy="200"></ellipse>
                            <image id="SvgjsImage1068" :xlink:href="baseurl + 'assets/images/3circles/ownership.png'" width="216" height="57" x="90" y="385"></image>
                        </g>
                        <g id="SvgjsG1107" class="axis">
                            <g id="SvgjsG1073" class="individual-axis" transform="translate(6 -8)">
                                <line id="SvgjsLine1074" x1="495" y1="333" x2="250" y2="20" marker-start="url(#marker-start)" marker-end="url(#marker-end)" opacity="0"></line>
                                <text id="SvgjsText1075" font-family="Helvetica, Arial, sans-serif" class="label" x="280" y="22.700000762939453" opacity="0" style="display: none;">
                                    <tspan id="SvgjsTspan1076" dy="20.8" x="280">Individual</tspan>
                                </text>
                                <text id="SvgjsText1077" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="460" y="302.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1078" dy="20.8" x="405">Adolescence</tspan>
                                </text>
                                <text id="SvgjsText1079" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="420" y="252.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1080" dy="20.8" x="365">Young Adult</tspan>
                                </text>
                                <text id="SvgjsText1081" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="380" y="202.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1082" dy="20.8" x="320">Family Founder</tspan>
                                </text>
                                <text id="SvgjsText1083" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="340" y="152.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1084" dy="20.8" x="295">Middle-age</tspan>
                                </text>
                                <text id="SvgjsText1085" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="300" y="102.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1086" dy="20.8" x="245">Pre-retirement</tspan>
                                </text>
                                <text id="SvgjsText1087" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="270" y="52.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1088" dy="20.8" x="215">Golden Ager</tspan>
                                </text>
                            </g>
                            <g id="SvgjsG1089" class="family-axis" transform="translate(6 -8)">
                                <line id="SvgjsLine1090" x1="495" y1="333" x2="125" y2="333" marker-start="url(#marker-start)" marker-end="url(#marker-end)" opacity="0"></line>
                                <text id="SvgjsText1091" font-family="Helvetica, Arial, sans-serif" class="label" x="150" y="297.70000076293945" opacity="0" style="display: none;">
                                    <tspan id="SvgjsTspan1092" dy="20.8" x="150">Family</tspan>
                                </text>
                                <text id="SvgjsText1093" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="460" y="342.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1094" dy="20.8" x="460">Single</tspan>
                                </text>
                                <text id="SvgjsText1095" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="400" y="342.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1096" dy="20.8" x="400">Couple</tspan>
                                </text>
                                <text id="SvgjsText1097" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="340" y="342.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1098" dy="20.8" x="340">Couple</tspan>
                                    <tspan id="SvgjsTspan1099" dy="16.8" x="340">with young</tspan>
                                    <tspan id="SvgjsTspan1100" dy="16.8" x="340">children</tspan>
                                </text>
                                <text id="SvgjsText1101" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="260" y="342.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1102" dy="20.8" x="260">Couple</tspan>
                                    <tspan id="SvgjsTspan1103" dy="16.8" x="260">with young</tspan>
                                    <tspan id="SvgjsTspan1104" dy="16.8" x="260">adults</tspan>
                                </text>
                                <text id="SvgjsText1105" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="180" y="342.70000076293945" opacity="0">
                                    <tspan id="SvgjsTspan1106" dy="20.8" x="170">Grandparents</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g id="circles-tooltip" class="circles-tooltip" visibility="hidden">
                        <rect id="circles-tooltip-bg" width="0" height="20" rx="5" ry="5"></rect>
                        <text id="circles-tooltip-text" font-family="Helvetica, Arial, sans-serif" x="6" y="25.700000762939453">
                            <tspan id="SvgjsTspan1111" dy="20.8" x="6">Tooltip</tspan>
                        </text>
                    </g>
                    <defs id="SvgjsDefs1001">
                        <marker id="marker-start" markerWidth="5" markerHeight="5" refX="2.5" refY="2.5" viewBox="0 0 5 5" orient="auto">
                            <image id="SvgjsImage1070" :xlink:href="baseurl + 'assets/images/3circles/circle-white.png'" width="5" height="5"></image>
                        </marker>
                        <marker id="marker-end" markerWidth="6" markerHeight="6" refX="3" refY="3" viewBox="0 0 6 6" orient="auto">
                            <image id="SvgjsImage1072" :xlink:href="baseurl + 'assets/images/3circles/triangle-red-dark.png'" width="6" height="6" transform="rotate(90 3 3)"></image>
                        </marker>
                    </defs>
                </svg>
            </div>


            <div id="personal-life-axis" v-if="personal_life_axis == 1">
                <div class="timeline-axis clearfix">
                    <div class="timeline-axis-center key-centercircle sequence-timeline-animation"></div>

                    <div class="schema-transform-point timeline-transform-point-individual">
                        <div class="schema timeline timeline-individual clearfix key-timelinebg sequence-timeline-animation" data-timeline-color="#e84324">
                            <ol class="clearfix">
                                <li class="timeline-period timeline-goldenager key-timelineperiodfadeinitial key-timelineperiodfade key-timelineperiodemphase sequence-timeline-animation">
                                    <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                        <strong>Golden-Ager</strong>
                                        <ul>
                                            <li>Mentoring</li>
                                            <li>Giving back</li>
                                        </ul>
                                        <div class="timeline-age">70+</div>
                                    </div>
                                </li>
                                <li class="timeline-period timeline-preretirement key-timelineperiodfadeinitial key-timelineperiodfade key-timelineperiodemphase sequence-timeline-animation">
                                    <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                        <strong>Pre-Retirement</strong>
                                        <ul>
                                            <li>Grow old while remaining young</li>
                                            <li>Delegate authority</li>
                                        </ul>
                                        <div class="timeline-age">60-70</div>
                                    </div>
                                </li>
                                <li class="timeline-period timeline-middleage key-timelineperiodfadeinitial key-timelineperiodfade key-timelineperiodemphase sequence-timeline-animation">
                                    <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                    <strong>Middle-Age</strong>
                                    <ul>
                                        <li>Create a legacy</li>
                                        <li>Grow old while remaining young</li>
                                    </ul>
                                    <div class="timeline-age">45-60</div>
                                    </div>
                                </li>
                                <li class="timeline-period timeline-familyfounder key-timelineperiodfadeinitial key-timelineperiodfade key-timelineperiodemphase sequence-timeline-animation">
                                    <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                    <strong>Family Founder</strong>
                                    <ul>
                                        <li>Accept own limitations</li>
                                        <li>Articulate new goal's</li>
                                    </ul>
                                    <div class="timeline-age">30-45</div>
                                    </div>
                                </li>
                                <li class="timeline-period timeline-youngadult key-timelineperiodfadeinitial key-timelineperiodfade key-timelineperiodemphase sequence-timeline-animation">
                                    <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                    <strong>Young Adult</strong>
                                    <ul>
                                        <li>Explore opportunities</li>
                                        <li>Engaging in a relationship</li>
                                        <li>Become oneself</li>
                                    </ul>
                                    <div class="timeline-age">18-30</div>
                                    </div>
                                </li>
                                <li class="timeline-period timeline-adolescence key-timelineperiodfadeinitial key-timelineperiodfade key-timelineperiodemphase sequence-timeline-animation">
                                    <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                    <strong>Adolescence</strong>
                                    <ul>
                                        <li>Envision one's dream</li>
                                    </ul>
                                    <div class="timeline-age">13-18</div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div class="schema timeline timeline-family clearfix key-timelinebg sequence-timeline-animation" data-timeline-color="#af1e3d">
                        <ol class="clearfix">
                            <li class="timeline-period timeline-grandparents key-timelineperiodfadeinitial key-timelineperiodfade sequence-timeline-animation">
                                <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                <strong>Grandparents</strong>
                                </div>
                            </li>
                        <li class="timeline-period timeline-coupleadults key-timelineperiodfadeinitial key-timelineperiodfade sequence-timeline-animation">
                            <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                <strong>Couple<br>— Young Adults</strong>
                                </div>
                            </li>
                            <li class="timeline-period timeline-couplechildren key-timelineperiodfadeinitial key-timelineperiodfade sequence-timeline-animation">
                                <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                <strong>Couple<br>— Young Children</strong>
                                </div>
                            </li>
                            <li class="timeline-period timeline-couple key-timelineperiodfadeinitial key-timelineperiodfade sequence-timeline-animation">
                                <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                <strong>Couple</strong>
                                </div>
                            </li>
                            <li class="timeline-period timeline-single key-timelineperiodfadeinitial key-timelineperiodfade sequence-timeline-animation">
                                <div class="timeline-period-text key-timelinebg sequence-timeline-animation">
                                <strong>Single</strong>
                                </div>
                            </li>
                        </ol>
                    </div>

                    <div class="timeline-circle"></div>
                </div>
                <div class="timeline-emphase"></div>
            </div>





            <div id="family-business-life-cycles" v-if="family_business_life_cycles == 1">
                <svg id="SvgjsSvg1000" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%" xmlns:xlink="http://www.w3.org/1999/xlink" class="circles">
                    <g id="SvgjsG1099" class="circles-3" transform="scale(0.9 0.9) translate(-94.44444444444444 27.77777777777778)">
                        <g id="circle-1" data-border="none" data-labelPosition="over" data-label="Family" class="family circle-1 text-over" transform="translate(137.5 10)">
                            <ellipse id="SvgjsEllipse1101" rx="200" ry="200" cx="200" cy="200"></ellipse>
                            <image id="SvgjsImage1102" :xlink:href="baseurl + 'assets/images/3circles/family.png'" width="96" height="125" x="-25" y="20"></image>
                        </g>
                        <g id="circle-2" data-border="none" data-labelPosition="over" data-label="Business" class="business circle-2 text-over" transform="translate(465.5 10)">
                            <ellipse id="SvgjsEllipse1104" rx="200" ry="200" cx="200" cy="200"></ellipse>
                            <image id="SvgjsImage1105" :xlink:href="baseurl + 'assets/images/3circles/business.png'" width="134" height="144" x="275" y="-20"></image>
                        </g>
                        <g id="circle-3" data-border="none" data-labelPosition="over" data-label="Ownership" class="ownership circle-3 text-over" transform="translate(300 254)">
                            <ellipse id="SvgjsEllipse1107" rx="200" ry="200" cx="200" cy="200"></ellipse>
                            <image id="SvgjsImage1108" :xlink:href="baseurl + 'assets/images/3circles/ownership.png'" width="216" height="57" x="90" y="385"></image>
                        </g>
                        <g id="SvgjsG1187" class="axis">
                            <g id="SvgjsG1113" class="individual-axis" transform="translate(3 -8)">
                                <line id="SvgjsLine1114" x1="495" y1="333" x2="270" y2="20" marker-start="url(#marker-start)" marker-end="url(#marker-end-red)"></line>
                                <text id="SvgjsText1115" font-family="Helvetica, Arial, sans-serif" class="label" x="300" y="12.950000762939453">
                                    <tspan id="SvgjsTspan1116" dy="20.8" x="300">Individual</tspan>
                                </text>
                                <text id="SvgjsText1117" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="480" y="302.95000076293945">
                                    <tspan id="SvgjsTspan1118" dy="20.8" x="400">Adolescence</tspan>
                                </text>
                                <text id="SvgjsText1119" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="440" y="252.95000076293945">
                                    <tspan id="SvgjsTspan1120" dy="20.8" x="380">Young Adult</tspan>
                                </text>
                                <text id="SvgjsText1121" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="400" y="202.95000076293945">
                                    <tspan id="SvgjsTspan1122" dy="20.8" x="340">Family Founder</tspan>
                                </text>
                                <text id="SvgjsText1123" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="360" y="152.95000076293945">
                                    <tspan id="SvgjsTspan1124" dy="20.8" x="300">Middle-age</tspan>
                                </text>
                                <text id="SvgjsText1125" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="320" y="102.95000076293945">
                                    <tspan id="SvgjsTspan1126" dy="20.8" x="270">Pre-retirement</tspan>
                                </text>
                                <text id="SvgjsText1127" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="290" y="52.95000076293945">
                                    <tspan id="SvgjsTspan1128" dy="20.8" x="230">Golden Ager</tspan>
                                </text>
                            </g>
                            <g id="SvgjsG1129" class="family-axis" transform="translate(3 -8)">
                                <line id="SvgjsLine1130" x1="495" y1="333" x2="125" y2="333" marker-start="url(#marker-start)" marker-end="url(#marker-end-red)"></line>
                                <text id="SvgjsText1131" font-family="Helvetica, Arial, sans-serif" class="label" x="150" y="297.95000076293945">
                                    <tspan id="SvgjsTspan1132" dy="20.8" x="150">Family</tspan>
                                </text>
                                <text id="SvgjsText1133" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="460" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1134" dy="20.8" x="460">Single</tspan>
                                </text>
                                <text id="SvgjsText1135" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="400" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1136" dy="20.8" x="400">Couple</tspan>
                                </text>
                                <text id="SvgjsText1137" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="340" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1138" dy="20.8" x="340">Couple</tspan>
                                    <tspan id="SvgjsTspan1139" dy="20.8" x="340">with young</tspan>
                                    <tspan id="SvgjsTspan1140" dy="20.8" x="340">children</tspan>
                                </text>
                                <text id="SvgjsText1141" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="260" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1142" dy="20.8" x="260">Couple</tspan>
                                    <tspan id="SvgjsTspan1143" dy="20.8" x="260">with young</tspan>
                                    <tspan id="SvgjsTspan1144" dy="20.8" x="260">adults</tspan>
                                </text>
                                <text id="SvgjsText1145" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="180" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1146" dy="20.8" x="180">Grandparents</tspan>
                                </text>
                            </g>
                            <g id="SvgjsG1149" class="business-axis" transform="translate(3 -8)" opacity="0">
                                <line id="SvgjsLine1150" x1="495" y1="333" x2="720" y2="20" marker-start="url(#marker-start)" marker-end="url(#marker-end-blue)"></line>
                                <text id="SvgjsText1151" font-family="Helvetica, Arial, sans-serif" class="label" x="630" y="12.950000762939453">
                                    <tspan id="SvgjsTspan1152" dy="20.8" x="630">Business</tspan>
                                </text>
                                <text id="SvgjsText1153" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="575" y="272.95000076293945">
                                    <tspan id="SvgjsTspan1154" dy="20.8" x="555">Start-up</tspan>
                                </text>
                                <text id="SvgjsText1155" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="610" y="222.95000076293945">
                                    <tspan id="SvgjsTspan1156" dy="20.8" x="590">Growth</tspan>
                                </text>
                                <text id="SvgjsText1157" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="660" y="172.95000076293945">
                                    <tspan id="SvgjsTspan1158" dy="20.8" x="640">Expansion</tspan>
                                </text>
                                <text id="SvgjsText1159" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="680" y="122.95000076293945">
                                    <tspan id="SvgjsTspan1160" dy="20.8" x="660">Mature</tspan>
                                </text>
                                <text id="SvgjsText1161" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="720" y="72.95000076293945">
                                    <tspan id="SvgjsTspan1162" dy="20.8" x="700">Decline</tspan>
                                </text>
                            </g>
                            <g id="SvgjsG1177" class="ownership-axis" transform="translate(3 -8)" opacity="0">
                                <line id="SvgjsLine1178" x1="495" y1="333" x2="495" y2="633" marker-start="url(#marker-start)" marker-end="url(#marker-end-gold)"></line>
                                <text id="SvgjsText1179" font-family="Helvetica, Arial, sans-serif" class="label" x="515" y="597.9500007629395">
                                    <tspan id="SvgjsTspan1180" dy="20.8" x="515">Ownership</tspan>
                                </text>
                                <text id="SvgjsText1181" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="510" y="402.95000076293945">
                                    <tspan id="SvgjsTspan1182" dy="20.8" x="510">Single Owner</tspan>
                                </text>
                                <text id="SvgjsText1183" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="510" y="462.95000076293945">
                                    <tspan id="SvgjsTspan1184" dy="20.8" x="510">Multiple Owners</tspan>
                                </text>
                                <text id="SvgjsText1185" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="510" y="522.9500007629395">
                                    <tspan id="SvgjsTspan1186" dy="20.8" x="510">Multigenerational</tspan>
                                </text>
                            </g>
                            <g id="SvgjsG1163" class="industry-axis" transform="translate(3 -8)" opacity="0">
                                <line id="SvgjsLine1164" x1="495" y1="333" x2="840" y2="333" marker-start="url(#marker-start)" marker-end="url(#marker-end-blue)"></line>
                                <text id="SvgjsText1165" font-family="Helvetica, Arial, sans-serif" class="label" x="770" y="297.95000076293945">
                                    <tspan id="SvgjsTspan1166" dy="20.8" x="770">Industry</tspan>
                                </text>
                                <text id="SvgjsText1167" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="520" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1168" dy="20.8" x="520">Infancy</tspan>
                                </text>
                                <text id="SvgjsText1169" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="580" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1170" dy="20.8" x="580">Growth</tspan>
                                </text>
                                <text id="SvgjsText1171" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="640" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1172" dy="20.8" x="640">Maturity</tspan>
                                </text>
                                <text id="SvgjsText1173" font-family="Helvetica, Arial, sans-serif" class="axis-element" x="700" y="342.95000076293945">
                                    <tspan id="SvgjsTspan1174" dy="20.8" x="700">Decline</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                    <g id="circles-tooltip" class="circles-tooltip" visibility="hidden">
                        <rect id="circles-tooltip-bg" width="0" height="20" rx="5" ry="5"></rect>
                        <text id="circles-tooltip-text" font-family="Helvetica, Arial, sans-serif" x="6" y="25.950000762939453">
                            <tspan id="SvgjsTspan1191" dy="20.8" x="6">Tooltip</tspan>
                        </text>
                    </g>
                    <defs id="SvgjsDefs1001">
                        <marker id="marker-start" markerWidth="5" markerHeight="5" refX="2.5" refY="2.5" viewBox="0 0 5 5" orient="auto">
                            <image id="SvgjsImage1110" :xlink:href="baseurl + 'assets/images/3circles/circle-white.png'" width="5" height="5"></image>
                        </marker>
                        <marker id="marker-end-red" markerWidth="6" markerHeight="6" refX="3" refY="3" viewBox="0 0 6 6" orient="auto">
                            <image id="SvgjsImage1112" :xlink:href="baseurl + 'assets/images/3circles/triangle-red-dark.png'" width="6" height="6" transform="rotate(90 3 3)"></image>
                        </marker>
                        <marker id="marker-end-blue" markerWidth="6" markerHeight="6" refX="3" refY="3" viewBox="0 0 6 6" orient="auto">
                            <image id="SvgjsImage1148" :xlink:href="baseurl + 'assets/images/3circles/triangle-blue.png'" width="6" height="6" transform="rotate(90 3 3)"></image>
                        </marker>
                        <marker id="marker-end-gold" markerWidth="6" markerHeight="6" refX="3" refY="3" viewBox="0 0 6 6" orient="auto">
                            <image id="SvgjsImage1176" :xlink:href="baseurl + 'assets/images/3circles/triangle-gold.png'" width="6" height="6" transform="rotate(90 3 3)"></image>
                        </marker>
                    </defs>
                </svg>
            </div>




            <div class="timeline" v-if="comparing_life == 1">

                <div id="comparing-life" class="row timelines">
                    <div>
                        <h2>1965</h2>
                        <div id="timeline-1965" class="timeline">
                            <ul>
                                <li class="start" style="display: none;"></li>
                                <li class="young-adult" style="display: none;"></li>
                                <li class="family-building" style="display: none;"></li>
                                <li class="middle-age" style="display: none;"></li>
                                <li class="golden-age" style="display: none;"></li>
                                <li class="end" style="display: none;"></li>
                            </ul>
                            <div class="transition midlife-transition" style="display: none;"><p>Midlife Transition</p></div>
                            <div class="transition late-adult-transition" style="display: none;"><p>Late Adult Transition</p></div>
                        </div>
                        <div id="timeline-ages" class="timeline">
                            <ul>
                                <li class="legend">Age</li>
                                <li class="age age-10">10</li>
                                <li class="age age-15">15</li>
                                <li class="age age-20">20</li>
                                <li class="age age-25">25</li>
                                <li class="age age-30">30</li>
                                <li class="age age-35">35</li>
                                <li class="age age-40">40</li>
                                <li class="age age-45">45</li>
                                <li class="age age-50">50</li>
                                <li class="age age-55">55</li>
                                <li class="age age-60">60</li>
                                <li class="age age-65">65</li>
                                <li class="age age-70">70</li>
                                <li class="age age-75">75</li>
                                <li class="age age-80">80</li>
                                <li class="age age-85">85</li>
                            </ul>
                        </div>
                        <div id="timeline-2015" class="timeline">
                            <ul>
                                <li class="start" style="display: none;"></li>
                                <li class="young-adult" style="display: none;"></li>
                                <li class="family-building" style="display: none;"></li>
                                <li class="middle-age" style="display: none;"></li>
                                <li class="golden-age" style="display: none;"></li>
                                <li class="end" style="display: none;"></li>
                            </ul>
                            <div class="transition midlife-transition" style="display: none;"><p>Midlife Transition</p></div>
                            <div class="transition late-adult-transition" style="display: none;"><p>Late Adult Transition</p></div>
                        </div>
                        <h2>2015</h2>

                    </div>


                    <!--div class="button-timeline">
                        <div class="prev-timeline">&lt;</div>
                        <div class="next-timeline">&gt;</div>
                        <div class="clearfix"></div>
                    </div-->
                    <div class="row legend">
                        <div class="col-md-3 col-sm-3 young-adult">
                            <div class="circle"></div>
                            <h3>Young Adult</h3>
                        </div>
                        <div class="col-md-3 col-sm-3 family-building">
                            <div class="circle"></div>
                            <h3>Family Building</h3>
                        </div>
                        <div class="col-md-3 col-sm-3 middle-age">
                            <div class="circle"></div>
                            <h3>Middle Age</h3>
                        </div>
                        <div class="col-md-3 col-sm-3 golden-age">
                            <div class="circle"></div>
                            <h3>Golden Age</h3>
                        </div>
                    </div>
                    <div class="row">
                        <p class="source">Source: © Business Families Foundation 2014</p>
                    </div>
                </div>
                
            </div>
        </div>











        <div v-if="model == 'c1p1s3t3'" class="tile4">
            <div class="audio svg-sync">
                <h1>How values influence behaviour</h1>
                
                <audio ref="audio4" @timeupdate="onTimeUpdate" controls id="audio" :src="baseurl + 'assets/audios/camp1path1step3tile3.mp3'"></audio>
                
                <div class="transcript">
                    <p>Values are what guide our behaviours and decision-making. Your core values are instilled in you from your family, and often carry over into your values as an owner. For example, if one of your core family values is sincerity, as an owner this means you likely have a high level of integrity, which will influence your interactions, your decision-making and your problem solving. That same sincerity may lead you to be brutally honest, even in times when it might be to your advantage to remain quite! What is certain is that for good, or for worse, your values will shape your behaviour as an owner.</p>
                </div>
            </div>


            <div id="ownership-ellipses">
                <svg id="SvgjsSvg1000" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%" xmlns:xlink="http://www.w3.org/1999/xlink" class="ellipses">
                    <g id="SvgjsG1006" transform="translate(5 5)">
                        <g id="SvgjsG1007" class="ellipse ellipse-behaviors">
                            <ellipse id="SvgjsEllipse1008" rx="450" ry="310" cx="450" cy="310" style=""></ellipse>
                            <text id="SvgjsText1009" font-family="Helvetica, Arial, sans-serif" class="title" x="758.34765625" y="311.20000076293945">
                                <tspan id="SvgjsTspan1010" dy="20.8" x="758.34765625">Behaviors</tspan>
                            </text>
                            <text id="SvgjsText1011" font-family="Helvetica, Arial, sans-serif" class="value value-communicate subtitle-interacting" x="336.4765625" y="30.05000114440918">
                                <tspan id="SvgjsTspan1012" dy="20.8" x="336.4765625">How we</tspan>
                                <tspan id="SvgjsTspan1013" dy="20.8" x="336.4765625">communicate</tspan>
                            </text>
                            <text id="SvgjsText1014" font-family="Helvetica, Arial, sans-serif" class="value value-conclusions" x="725.98046875" y="380.0500011444092">
                                <tspan id="SvgjsTspan1015" dy="20.8" x="725.98046875">How we draw</tspan>
                                <tspan id="SvgjsTspan1016" dy="20.8" x="725.98046875">conclusions</tspan>
                            </text>
                            <text id="SvgjsText1017" font-family="Helvetica, Arial, sans-serif" class="value value-ourselves" x="509.95703125" y="50.05000114440918">
                                <tspan id="SvgjsTspan1018" dy="20.8" x="509.95703125">How we see ourselves</tspan>
                                <tspan id="SvgjsTspan1019" dy="20.8" x="509.95703125">(group/individual)</tspan>
                            </text>
                            <text id="SvgjsText1020" font-family="Helvetica, Arial, sans-serif" class="value value-power subtitle-making-decision" x="527.96875" y="525.0500011444092">
                                <tspan id="SvgjsTspan1021" dy="20.8" x="527.96875">How we</tspan>
                                <tspan id="SvgjsTspan1022" dy="20.8" x="527.96875">make decisions</tspan>
                            </text>
                            <text id="SvgjsText1023" font-family="Helvetica, Arial, sans-serif" class="value value-Focus" x="630.4765625" y="115.45000076293945">
                                <tspan id="SvgjsTspan1024" dy="20.8" x="630.4765625">How to prioritize</tspan>
                            </text>
                            <text id="SvgjsText1025" font-family="Helvetica, Arial, sans-serif" class="value value-differences" x="709.59765625" y="170.05000114440918">
                                <tspan id="SvgjsTspan1026" dy="20.8" x="709.59765625">How we embrace</tspan>
                                <tspan id="SvgjsTspan1027" dy="20.8" x="709.59765625">differences of opinion</tspan>
                            </text>
                            <text id="SvgjsText1028" font-family="Helvetica, Arial, sans-serif" class="value value-control" x="640.9765625" y="465.0500011444092">
                                <tspan id="SvgjsTspan1029" dy="20.8" x="640.9765625">How we use</tspan>
                                <tspan id="SvgjsTspan1030" dy="20.8" x="640.9765625">our control</tspan>
                            </text>
                            <text id="SvgjsText1031" font-family="Helvetica, Arial, sans-serif" class="value value-explain subtitle-problem-solving" x="369.47265625" y="545.0500011444092">
                                <tspan id="SvgjsTspan1032" dy="20.8" x="369.47265625">How we</tspan>
                                <tspan id="SvgjsTspan1033" dy="20.8" x="369.47265625">solve problems</tspan>
                            </text>
                            <text id="SvgjsText1034" font-family="Helvetica, Arial, sans-serif" class="value value-terms" x="737.46875" y="250.45000076293945">
                                <tspan id="SvgjsTspan1035" dy="20.8" x="737.46875">How we envision</tspan>
                            </text>
                        </g>
                        <g id="SvgjsG1036" class="ellipse ellipse-ownership" transform="translate(0 90)">
                            <ellipse id="SvgjsEllipse1037" rx="320" ry="225" cx="320" cy="225" style=""></ellipse>
                            <text id="SvgjsText1038" font-family="Helvetica, Arial, sans-serif" class="title" x="530.24609375" y="221.20000076293945">
                                <tspan id="SvgjsTspan1039" dy="20.8" x="530.24609375">Ownership</tspan>
                            </text>
                            <text id="SvgjsText1040" font-family="Helvetica, Arial, sans-serif" class="value value-loyalty" x="401.48046875" y="65.45000076293945">
                                <tspan id="SvgjsTspan1041" dy="20.8" x="401.48046875">Loyalty</tspan>
                            </text>
                            <text id="SvgjsText1042" font-family="Helvetica, Arial, sans-serif" class="value value-integrity" x="512.984375" y="130.45000076293945" style="font-weight: normal;">
                                <tspan id="SvgjsTspan1043" dy="20.8" x="512.984375">Integrity</tspan>
                            </text>
                            <text id="SvgjsText1044" font-family="Helvetica, Arial, sans-serif" class="value value-passion" x="257.98046875" y="400.45000076293945">
                                <tspan id="SvgjsTspan1045" dy="20.8" x="257.98046875">Passion</tspan>
                            </text>
                            <text id="SvgjsText1046" font-family="Helvetica, Arial, sans-serif" class="value value-trust" x="259.828125" y="25.450000762939453">
                                <tspan id="SvgjsTspan1047" dy="20.8" x="259.828125">Trust</tspan>
                            </text>
                            <text id="SvgjsText1048" font-family="Helvetica, Arial, sans-serif" class="value value-respect" x="511.98046875" y="310.45000076293945">
                                <tspan id="SvgjsTspan1049" dy="20.8" x="511.98046875">Respect</tspan>
                            </text>
                            <text id="SvgjsText1050" font-family="Helvetica, Arial, sans-serif" class="value value-commitment" x="388.9921875" y="370.45000076293945">
                                <tspan id="SvgjsTspan1051" dy="20.8" x="388.9921875">Commitment</tspan>
                            </text>
                            <line id="SvgjsLine1052" x1="615" y1="235" x2="675" y2="235" class="line-ellipse line-family-ownership" marker-start="url(#SvgjsMarker1053)" marker-end="url(#SvgjsMarker1055)"></line>
                        </g>
                        <g id="SvgjsG1057" class="ellipse ellipse-family" transform="translate(0 160)">
                            <ellipse id="SvgjsEllipse1058" rx="215" ry="160" cx="215" cy="160" style=""></ellipse>
                            <text id="SvgjsText1059" font-family="Helvetica, Arial, sans-serif" class="title" x="292.45703125" y="151.20000076293945">
                                <tspan id="SvgjsTspan1060" dy="20.8" x="292.45703125">Family</tspan>
                            </text>
                            <text id="SvgjsText1061" font-family="Helvetica, Arial, sans-serif" class="value value-sincerity" x="155.48828125" y="40.45000076293945" style="font-weight: bold;">
                                <tspan id="SvgjsTspan1062" dy="20.8" x="155.48828125">Sincerity</tspan>
                            </text>
                            <text id="SvgjsText1063" font-family="Helvetica, Arial, sans-serif" class="value value-courage" x="270.4765625" y="220.45000076293945">
                                <tspan id="SvgjsTspan1064" dy="20.8" x="270.4765625">Courage</tspan>
                            </text>
                            <text id="SvgjsText1065" font-family="Helvetica, Arial, sans-serif" class="value value-adventure" x="338.97265625" y="100.45000076293945">
                                <tspan id="SvgjsTspan1066" dy="20.8" x="338.97265625">Adventure</tspan>
                            </text>
                            <text id="SvgjsText1067" font-family="Helvetica, Arial, sans-serif" class="value value-honesty" x="161.98046875" y="255.45000076293945" style="font-weight: normal;">
                                <tspan id="SvgjsTspan1068" dy="20.8" x="161.98046875">Honesty</tspan>
                            </text>
                            <text id="SvgjsText1069" font-family="Helvetica, Arial, sans-serif" class="value value-modesty" x="250.984375" y="65.45000076293945">
                                <tspan id="SvgjsTspan1070" dy="20.8" x="250.984375">Modesty</tspan>
                            </text>
                            <line id="SvgjsLine1071" x1="355" y1="165" x2="455" y2="165" class="line-ellipse line-family-ownership" marker-end="url(#SvgjsMarker1072)"></line>
                        </g>
                        <g id="SvgjsG1074" class="ellipse ellipse-values" transform="translate(0 237)">
                            <ellipse id="SvgjsEllipse1075" rx="85" ry="85" cx="85" cy="85" style=""></ellipse>
                            <text id="SvgjsText1076" font-family="Helvetica, Arial, sans-serif" class="title" x="78.18359375" y="74.20000076293945">
                                <tspan id="SvgjsTspan1077" dy="20.8" x="78.18359375">Values</tspan>
                            </text>
                            <line id="SvgjsLine1078" x1="145" y1="88" x2="220" y2="88" class="line-ellipse line-values-family" marker-end="url(#SvgjsMarker1079)"></line>
                        </g>
                    </g>
                    <defs id="SvgjsDefs1001">
                        <marker id="SvgjsMarker1053" markerWidth="4" markerHeight="4" refX="2" refY="2" viewBox="0 0 4 4" orient="auto">
                            <image id="SvgjsImage1054" :xlink:href="baseurl + 'assets/images/3circles/triangle-blue2.png'" width="4" height="4" transform="rotate(-90 2 2)"></image>
                        </marker>
                        <marker id="SvgjsMarker1055" markerWidth="4" markerHeight="4" refX="2" refY="2" viewBox="0 0 4 4" orient="auto">
                            <image id="SvgjsImage1056" :xlink:href="baseurl + 'assets/images/3circles/triangle-blue2.png'" width="4" height="4" transform="rotate(90 2 2)"></image>
                        </marker>
                        <marker id="SvgjsMarker1072" markerWidth="4" markerHeight="4" refX="2" refY="2" viewBox="0 0 4 4" orient="auto">
                            <image id="SvgjsImage1073" :xlink:href="baseurl + 'assets/images/3circles/triangle-blue2.png'" width="4" height="4" transform="rotate(90 2 2)"></image>
                        </marker>
                        <marker id="SvgjsMarker1079" markerWidth="4" markerHeight="4" refX="2" refY="2" viewBox="0 0 4 4" orient="auto">
                            <image id="SvgjsImage1080" :xlink:href="baseurl + 'assets/images/3circles/triangle-blue2.png'" width="4" height="4" transform="rotate(90 2 2)"></image>
                        </marker>
                    </defs>
                </svg>
            </div>


        </div>




        <div v-if="model == 'c1p3s1t5'" class="tile5">
            <div class="audio svg-sync">
                <h1>Stages of a Successful Multi-Generational Family Owned Business</h1>
                
                <audio ref="audio5" @timeupdate="onTimeUpdate" controls id="audio" :src="baseurl + 'assets/audios/ownership-stages.mp3'"></audio>
                
                <div class="transcript">
                    <p></p>
                </div>
            </div>

            
            <div class="ownershipstages">
                <h2 class="north">External-Macro</h2>
                <h2 class="west">Manager</h2>
                <h2 class="east">Owner</h2>
                <h2 class="south">Internal-Micro</h2>

                <div class="animatedCompass i1"></div>
                <div class="animatedCompass i2"></div>
                <div class="animatedCompass i3"></div>
                <div class="animatedCompass i4"></div>

                <div class="workingin"><span>Working<br><strong>in</strong> the<br>business</span></div>
                <div class="workingon"><span>Working<br><strong>on</strong> the<br>business</span></div>

                <div class="shortterm"><span><strong>Short</strong> Term</span></div>
                <div class="longterm"><span><strong>Long</strong> Term</span></div>

                <div class="core">
                    <div class="q1">
                        <ul>
                            <li class="item1">Innovation</li>
                            <li class="item2">Monitoring<br>Breakdowns</li>
                        </ul>
                    </div>
                    <div class="q2">
                        <ul>
                            <li class="item1">Trends</li>
                            <li class="item2">Environment</li>
                            <li class="item3">Corporate Social<br>Responsability (CSR)</li>
                            <li class="item4">Approve Acquisitions<br>&amp; Mergers</li>
                        </ul>
                    </div>
                    <div class="q3">
                        <ul>
                            <li class="item1">Risk</li>
                            <li class="item2">Strategic</li>
                            <li class="item3">Performance of CEO</li>
                            <li class="item0">Return on investment</li>
                            <li class="item4">Monitor Business<br>Performance</li>
                            <li class="item5">Financial Resources</li>
                        </ul>
                    </div>
                    <div class="q4">
                        <ul>
                            <li class="item1">Operations</li>
                            <li class="item2">Results</li>
                            <li class="item3">Performance &amp;<br>Efficiency</li>
                            <li class="item4">Human Resources</li>
                        </ul>
                    </div>

                    <div class="growth">
                        <h3 class="professional"><span>Multi Generational</span> Professional</h3>
                        <h3 class="managerial"><span>Multiple Owners</span> Managerial</h3>
                        <h3 class="entrepreneurial"><span>Single Owner</span> Entrepreneurial</h3>
                    </div>
                </div>
            </div>

        </div>


        




    </div>
</template>


<script>

export default {
    name: "three-circle-model",
    components: {

    },
    data() {
        return {
            currentTime: 0,
            personal_life_cycles: 1,
            personal_life_axis: 0,
            family_business_life_cycles: 0,
            comparing_life: 0
        };
    },
    props: {
        model: {},
    },
    
    computed: { },
    
    methods: {

        
        onTimeUpdate () {
            switch (this.model) {
                case 'c1p1s1t1':
                    this.currentTime =  Math.round(this.$refs.audio1.currentTime);
                    switch (this.currentTime) {
                        case 0:
                            document.getElementById("circle-2").setAttribute("transform", "translate(500 -175)");
                            document.getElementById("circle-3").setAttribute("transform", "translate(300 250)");

                            document.querySelector("#circles-model .family text").setAttribute("opacity", 0);
                            document.querySelector("#circles-model .business text").setAttribute("opacity", 0);
                            document.querySelector("#circles-model .ownership text").setAttribute("opacity", 0);
                            break;

                        case 2:
                            document.querySelector("#circles-model .family text").setAttribute("opacity", 1);
                            break;

                         case 4:
                            document.querySelector("#circles-model .business text").setAttribute("opacity", 1);
                            break;

                        case 6:
                            document.querySelector("#circles-model .ownership text").setAttribute("opacity", 1);
                            break;

                        case 12:
                            document.querySelector("#circles-model .business").animate({
                                transform: 'translateX(350px) translateY(-175px)'
                            },{duration: 2000}); 

                            document.querySelector("#circles-model .ownership").animate({
                                transform: 'translateX(200px) translateY(50px)'
                            },{duration: 2000}); 

                            break;

                        case 14:
                            document.querySelector("#circles-model .business").setAttribute("transform", "translate(350 -175)");
                            document.querySelector("#circles-model .ownership").setAttribute("transform", "translate(200 50)");

                            
                            break;
                    }

                    break;

                case 'c1p1s1t2':
                    this.currentTime =  Math.round(this.$refs.audio2.currentTime);
                    switch (this.currentTime) {
                        case 18:
                            document.getElementById("circle-number-2").setAttribute("fill", "#FFFFFF");
                            break;

                        case 20:
                            document.getElementById("circle-number-2").setAttribute("fill", "#000000");
                            break;

                        case 23:
                            document.getElementById("circle-number-1").setAttribute("fill", "#FFFFFF");
                            break;

                        case 25:
                            document.getElementById("circle-number-1").setAttribute("fill", "#000000");
                            break;

                    }

                    break;

                case 'c1p1s1t3':
                    this.currentTime =  Math.round(this.$refs.audio3.currentTime);
                    
                    switch (this.currentTime) {
                        case 10:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelector("#personal-life-cycles .circles-3").animate(
                                [
                                    {transform: 'scale(1.4 1.4)'}
                                ],
                                {duration: 2000}
                            );

                            break;

                        case 12:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelector("#personal-life-cycles .circles-3").setAttribute("transform", 'scale(1.4 1.4) translate(-60.714285714285715 17.857142857142858)');
                           
                            break;

                         case 14:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelector("#personal-life-cycles .circles-3 .axis .individual-axis line").setAttribute("stroke", "#C30000");
                            document.querySelector("#personal-life-cycles .circles-3 .axis .individual-axis line").setAttribute("opacity", 1);

                            document.querySelector("#personal-life-cycles .circles-3 .axis .individual-axis text.label").setAttribute("opacity", 1);

                            document.querySelector("#personal-life-cycles .circles-3 .axis .individual-axis text.label").setAttribute("style", "display: block");
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .individual-axis text.axis-element")[0].setAttribute("opacity", 1);
                            break;
                        
                        case 16:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .individual-axis text.axis-element")[1].setAttribute("opacity", 1);
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .individual-axis text.axis-element")[2].setAttribute("opacity", 1);
                            break;

                        case 17:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .individual-axis text.axis-element")[3].setAttribute("opacity", 1);
                            
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .individual-axis text.axis-element")[4].setAttribute("opacity", 1);
                            break;

                        case 18:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .individual-axis text.axis-element")[5].setAttribute("opacity", 1);
                            break;

                        case 24:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelector("#personal-life-cycles .circles-3 .axis .family-axis line").setAttribute("stroke", "#C30000");
                            document.querySelector("#personal-life-cycles .circles-3 .axis .family-axis line").setAttribute("opacity", 1);

                            document.querySelector("#personal-life-cycles .circles-3 .axis .family-axis text.label").setAttribute("opacity", 1);

                            document.querySelector("#personal-life-cycles .circles-3 .axis .family-axis text.label").setAttribute("style", "display: block");

                            break;

                        case 28:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .family-axis text.axis-element")[0].setAttribute("opacity", 1);
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .family-axis text.axis-element")[1].setAttribute("opacity", 1);
                            break;

                        case 29:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .family-axis text.axis-element")[2].setAttribute("opacity", 1);
                            
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .family-axis text.axis-element")[3].setAttribute("opacity", 1);
                            break;

                        case 30:
                            this.personal_life_cycles = 1;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-cycles .circles-3 .axis .family-axis text.axis-element")[4].setAttribute("opacity", 1);
                            break;

                        case 35:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 1;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;

                            var hover = document.querySelector(".timeline-emphase");

                            for (let i = 0; i < document.querySelectorAll("#personal-life-axis .schema.timeline ol > li.timeline-period").length; i++) {
                                let el = document.querySelectorAll("#personal-life-axis .schema.timeline ol > li.timeline-period")[i];
                            
                                el.addEventListener("mouseover", (event) => {
                                    let e = event.target;
                                    let parent = e.parentNode;
                                    if (e.classList.contains("timeline-period")) {
                                        hover.innerHTML = e.innerHTML;
                                        hover.setAttribute("style", "display: block;");
                                        //e.classList.toggle('emphase-current');
                                    }
                                }, false);

                                el.addEventListener("mouseout", (event) => {
                                    let e = event.target;
                                    if (e.classList.contains("timeline-period")) {
                                        hover.innerHTML = '';
                                        hover.setAttribute("style", "");
                                        //e.classList.toggle('emphase-current');
                                    }
                                }, false);

                            }
                            break;

                        case 39:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 1;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[5].setAttribute("style", "opacity: 1;");
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[4].setAttribute("style", "opacity: 1;");
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[3].setAttribute("style", "opacity: 1;");
                            break;

                        case 40:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 1;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[2].setAttribute("style", "opacity: 1;");
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[1].setAttribute("style", "opacity: 1;");
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[0].setAttribute("style", "opacity: 1;");
                            break;

                        case 41:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 1;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[10].setAttribute("style", "opacity: 1;");
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[9].setAttribute("style", "opacity: 1;");
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[8].setAttribute("style", "opacity: 1;");
                            break;

                        case 42:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 1;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 0;
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[7].setAttribute("style", "opacity: 1;");
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[6].setAttribute("style", "opacity: 1;");
                            document.querySelectorAll("#personal-life-axis .schema.timeline .timeline-period")[5].setAttribute("style", "opacity: 1;");
                            break;

                        case 56:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 1;
                            this.comparing_life = 0;
                            break;

                        case 78:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 1;
                            this.comparing_life = 0;

                            for (let i = 0; i < document.querySelector("#family-business-life-cycles .business-axis text").length; i++) {
                                let el = document.querySelector("#family-business-life-cycles .business-axis text")[i];
                                el.setAttribute("opacity", 0);
                            }

                            document.querySelector("#family-business-life-cycles .business-axis").setAttribute("opacity", 1);

                            break;

                        case 81:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 1;
                            this.comparing_life = 0;

                            for (let i = 0; i < document.querySelector("#family-business-life-cycles .ownership-axis text").length; i++) {
                                let el = document.querySelector("#family-business-life-cycles .ownership-axis text")[i];
                                el.setAttribute("opacity", 0);
                            }

                            document.querySelector("#family-business-life-cycles .ownership-axis").setAttribute("opacity", 1);

                            break;

                        case 85:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 1;
                            this.comparing_life = 0;

                            for (let i = 0; i < document.querySelector("#family-business-life-cycles .industry-axis text").length; i++) {
                                let el = document.querySelector("#family-business-life-cycles .industry-axis text")[i];
                                el.setAttribute("opacity", 0);
                            }

                            document.querySelector("#family-business-life-cycles .industry-axis").setAttribute("opacity", 1);

                            break;

                        case 95:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 1;

                            break;

                        case 96:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 1;

                            document.querySelector("#comparing-lif #timeline-1965 .start").setAttribute("style", "display: inline-block;");
                            document.querySelector("#comparing-lif #timeline-2015 .start").setAttribute("style", "display: inline-block;");
                            break;

                        case 98:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 1;

                            document.querySelector("#comparing-life #timeline-1965 .young-adult").setAttribute("style", "display: inline-block;");
                            document.querySelector("#comparing-life #timeline-2015 .young-adult").setAttribute("style", "display: inline-block;");
                            break;

                        case 100:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 1;

                            document.querySelector("#comparing-life #timeline-1965 .family-building").setAttribute("style", "display: inline-block;");
                            document.querySelector("#comparing-life #timeline-2015 .family-building").setAttribute("style", "display: inline-block;");
                            break;

                        case 102:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 1;

                            document.querySelector("#comparing-life #timeline-1965 .middle-age").setAttribute("style", "display: inline-block;");
                            document.querySelector("#comparing-life #timeline-2015 .middle-age").setAttribute("style", "display: inline-block;");
                            break;

                        case 104:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 1;

                            document.querySelector("#comparing-life #timeline-1965 .golden-age").setAttribute("style", "display: inline-block;");
                            document.querySelector("#comparing-life #timeline-2015 .golden-age").setAttribute("style", "display: inline-block;");
                            break;

                        case 106:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 1;

                            document.querySelector("#comparing-life #timeline-1965 .end").setAttribute("style", "display: inline-block;");
                            document.querySelector("#comparing-life #timeline-2015 .end").setAttribute("style", "display: inline-block;");
                            break;

                        case 118:
                            this.personal_life_cycles = 0;
                            this.personal_life_axis = 0;
                            this.family_business_life_cycles = 0;
                            this.comparing_life = 1;
                            
                            for (var i = 0; i < document.querySelectorAll("#comparing-life .timeline .transition").length; i++) {
                                let el = document.querySelectorAll("#comparing-life .timeline .transition")[i];
                                el.setAttribute("style", "display: block;");
                            }

                            break;
                        

                    }

                    break;

                
                case 'c1p1s3t3':
                    this.currentTime =  Math.round(this.$refs.audio4.currentTime);
                    
                    switch (this.currentTime) {
                        case 1:
                            document.querySelector("#ownership-ellipses .ellipse.ellipse-values ellipse").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse.ellipse-values text").animate({opacity: 1},{duration: 1000});

                            document.querySelector("#ownership-ellipses").className = 's1'; 
                            break;

                        case 7:
                            document.querySelector("#ownership-ellipses .ellipse-values line").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse-family ellipse").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse-family text.title").animate({opacity: 1},{duration: 1000});

                            document.querySelector("#ownership-ellipses").className = 's1 s2';
                            
                            break;

                        case 9:
                            document.querySelector("#ownership-ellipses .ellipse-family line").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse-ownership ellipse").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse-ownership text.title").animate({opacity: 1},{duration: 1000});
                            
                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3';
                            
                            break;

                        case 14:

                            document.querySelector("#ownership-ellipses .ellipse-family text.value").animate({opacity: 0.2},{duration: 500});

                            document.querySelector("#ownership-ellipses .ellipse-family text.value.value-sincerity").animate({opacity: 1},{duration: 1000});

                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3 s4';

                            break;

                        case 16:
                            document.querySelector("#ownership-ellipses .ellipse-ownership line").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse-behaviors ellipse").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse-behaviors text.title").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse-behaviors text.subtitle").animate({opacity: 1},{duration: 1000});
                            document.querySelector("#ownership-ellipses .ellipse-behaviors line.line-subtitle").animate({opacity: 1},{duration: 1000});

                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3 s4 s5';
                            
                            break;

                        case 18:

                            document.querySelector("#ownership-ellipses .ellipse-ownership text.value").animate({opacity: 0.2},{duration: 500});

                            document.querySelector("#ownership-ellipses .ellipse-ownership text.value.value-integrity").animate({opacity: 0.2},{duration: 1000});

                            document.querySelector("#ownership-ellipses .ellipse-behaviors text.value").animate({opacity: 1},{duration: 1000});

                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3 s4 s5 s6';
                            
                            break;

                        case 19:

                            document.querySelector("#ownership-ellipses .ellipse-behaviors text.value").animate({opacity: 1},{duration: 1000});

                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3 s4 s5 s6 s7';

                            break;

                        case 21:

                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3 s4 s5 s6 s7 s8';

                            break;

                        case 22:

                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3 s4 s5 s6 s7 s8 s9';

                            break;

                        case 23:

                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3 s4 s5 s6 s7 s8 s9 s10';

                            break;

                        case 33:

                            document.querySelector("#ownership-ellipses .ellipse-family text.value").animate({opacity: 1},{duration: 500});

                            document.querySelector("#ownership-ellipses .ellipse-ownership text.value").animate({opacity: 1},{duration: 500});

                            document.querySelector("#ownership-ellipses").className = 's1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11';

                            break;
                        

                    }

                    break;

                case 'c1p3s1t5':
                    this.currentTime =  Math.round(this.$refs.audio5.currentTime);
                    
                    switch (this.currentTime) {

                        case 1:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1';
                            break;

                        case 2:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2';
                            break;

                        case 4:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3';
                            break;

                        case 5:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4';
                            break;

                        case 8:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5';
                            break;
                        
                        case 9:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6';
                            break;

                        case 10:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7';
                            break;

                        case 11:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8';
                            break;

                        case 18:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9';
                            break;
                        
                        case 20:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10';
                            break;

                        case 23:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11';
                            break;

                        case 26:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12';
                            break;

                        case 27:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13';
                            break;

                        case 39:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14';
                            break;

                        case 49:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15';
                            break;

                        case 59:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16';
                            break;

                        case 67:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17';
                            break;

                        case 69:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18';
                            break;

                        case 74:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19';
                            break;

                        case 88:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20';
                            break;
                        
                        case 92:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21';
                            break;

                        case 94:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22';
                            break;

                        case 95:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23';
                            break;
                      
                        case 97:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24';
                            break;

                        case 104:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25';
                            break;

                        case 106:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26';
                            break;

                        case 119:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27';
                            break;

                        case 121:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28';
                            break;

                        case 130:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29';
                            break;

                        case 134:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30';
                            break;

                        case 146:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31';
                            break;

                        case 147:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32';
                            break;
                        
                        case 148:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33';
                            break;

                        case 150:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34';
                            break;

                        case 155:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35';
                            break;

                        case 158:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36';
                            break;

                        case 160:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37';
                            break;

                        case 162:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38';
                            break;

                        case 164:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39';
                            break;

                        case 166:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40';
                            break;

                        case 173:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41';
                            break;

                        case 175:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42';
                            break;

                        case 177:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42 s43';
                            break;

                        case 184:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42 s43 s44';
                            break;

                        case 185:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42 s43 s44 s45';
                            break;

                        case 186:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42 s43 s44 s45 s46';
                            break;

                        case 187:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42 s43 s44 s45 s46 s47';
                            break;

                        case 188:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42 s43 s44 s45 s46 s47 s48';
                            break;

                        case 189:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42 s43 s44 s45 s46 s47 s48 s49';
                            break;

                        case 190:
                            document.querySelector(".ownershipstages").className = 'ownershipstages s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 s32 s33 s34 s35 s36 s37 s38 s39 s40 s41 s42 s43 s44 s45 s46 s47 s48 s49 s50';
                            break;
                       
                    }

                    break;


            }

        }
    }
    
}

</script>

<style scoped>
    
        
</style>
